const directory = [
  {"city":"乌兰察布市","county":"察哈尔右翼中旗","school":"察右中旗民族学校"},
  {"city":"乌兰察布市","county":"集宁区","school":"乌兰察布市直属蒙古族小学"},
  {"city":"乌兰察布市 ","county":"","school":"四子王旗红格尔蒙校"},
  {"city":"乌兰察布市 ","county":"","school":"四子王旗蒙古族中学"},
  {"city":"乌兰察布市 ","county":"","school":"四子王旗蒙古族小学"},
  {"city":"乌兰察布市","county":"察哈尔右翼前旗","school":"察右前旗民族学校"},
  {"city":"乌兰察布市 ","county":"","school":"乌兰察布市蒙古族中学"},
  {"city":"乌兰察布市","county":"察哈尔右翼后旗","school":"察右后旗蒙古族学校"},
  {"city":"乌兰察布市 ","county":"","school":"四子王旗蒙古族中学初中"},
  {"city":"包头市","county":"滨河新区","school":"包头市滨河新区蒙古族中学"},
  {"city":"包头市","county":"九原区","school":"包头市九原区蒙古族小学"},
  {"city":"包头市","county":"昆都仑区","school":"包头市昆都仑区蒙古族学校"},
  {"city":"包头市","county":"达茂旗","school":"包头市达茂联合旗蒙古族学校"},
  {"city":"锡林郭勒盟","county":"西乌珠穆沁旗","school":"西乌珠穆沁旗蒙古族中学"},
  {"city":"锡林郭勒盟","county":"西乌珠穆沁旗","school":"西乌珠穆沁旗蒙古族第一小学"},
  {"city":"锡林郭勒盟","county":"西乌珠穆沁旗","school":"西乌珠穆沁旗蒙古族第二小学"},
  {"city":"锡林郭勒盟","county":"东乌珠穆沁旗","school":"东乌珠穆沁旗蒙古族中学"},
  {"city":"锡林郭勒盟","county":"东乌珠穆沁旗","school":"东乌珠穆沁旗蒙古族第一小学"},
  {"city":"锡林郭勒盟","county":"东乌珠穆沁旗","school":"东乌珠穆沁旗蒙古族第二小学"},
  {"city":"锡林郭勒盟","county":"东乌珠穆沁旗","school":"满都胡宝拉格学校"},
  {"city":"锡林郭勒盟","county":"正蓝旗","school":"正蓝旗蒙古族中学"},
  {"city":"锡林郭勒盟","county":"正蓝旗","school":"正蓝旗蒙古族小学"},
  {"city":"锡林郭勒盟","county":"正蓝旗","school":"桑根达来蒙古族学校"},
  {"city":"锡林郭勒盟","county":"太仆寺旗","school":"太仆寺旗蒙古族学校"},
  {"city":"锡林郭勒盟","county":"苏尼特右旗","school":"苏尼特右旗蒙古族中学"},
  {"city":"锡林郭勒盟","county":"苏尼特右旗","school":"苏尼特右旗蒙古族小学"},
  {"city":"锡林郭勒盟","county":"苏尼特右旗","school":"苏尼特右旗第三小学"},
  {"city":"锡林郭勒盟","county":"镶黄旗","school":"镶黄旗蒙古族中学"},
  {"city":"锡林郭勒盟","county":"镶黄旗","school":"锡盟镶黄旗蒙古族小学"},
  {"city":"锡林郭勒盟","county":"正镶白旗","school":"明安图小学 "},
  {"city":"锡林郭勒盟","county":"正镶白旗","school":"正镶白旗蒙古族中学"},
  {"city":"锡林郭勒盟","county":"阿巴嘎旗","school":"阿巴嘎旗蒙古族小学"},
  {"city":"锡林郭勒盟","county":"阿巴嘎旗","school":"阿巴嘎旗蒙古中学"},
  {"city":"锡林郭勒盟","county":"乌拉盖管理区","school":"乌拉盖管理区蒙古族学校"},
  {"city":"锡林郭勒盟","county":"锡林浩特市","school":"苏尼特左旗蒙古族小学"},
  {"city":"锡林郭勒盟","county":"锡林浩特市","school":"苏尼特左旗蒙古族中学"},
  {"city":"锡林郭勒盟","county":"锡林浩特市","school":"锡林郭勒盟锡林浩特市蒙古族第二小学"},
  {"city":"锡林郭勒盟","county":"锡林浩特市","school":"锡林浩特市民族小学"},
  {"city":"锡林郭勒盟","county":"锡林浩特市","school":"锡林浩特市蒙古族小学"},
  {"city":"锡林郭勒盟","county":"锡林浩特市","school":"锡林浩特市蒙古族中学"},
  {"city":"二连浩特市","county":"","school":"二连浩特市蒙古族中学"},
  {"city":"二连浩特市","county":"","school":"二连浩特市蒙古族小学"},
  {"city":"呼和浩特市","county":"赛罕区","school":"呼和浩特市赛罕区民族小学"},
  {"city":"呼和浩特市","county":"新城区","school":"呼和浩特市蒙古族学校"},
  {"city":"呼和浩特市","county":"赛罕区","school":"内蒙古师范大学附属中学"},
  {"city":"呼和浩特市","county":"赛罕区","school":"内师大附属蒙古族学校"},
  {"city":"呼和浩特市","county":"赛罕区","school":"呼和浩特市民族实验学校"}
]

export default directory;